import React, { useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Typography,
  message,
} from "antd";
import { postManageAccount } from "../../../api/Post";
import { putAccountStatus } from "../../../api/Put";

const { Text, Title } = Typography;

const ManageAccount = () => {
  const [msgErr, setMsgErr] = useState("");
  const [msgErrRole, setMsgErrRole] = useState("");

  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values) => {
    console.log("Success:", values);
    const res = await postManageAccount(values);
    console.log(res);
    if (res.error) setMsgErr(res.error);
    else {
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", "nbk_account_auto_generated.csv");
      a.click();
      window.URL.revokeObjectURL(url);
    }
  };

  const updateRole = async (values) => {
    const res = await putAccountStatus(values);
    if (res.error) setMsgErrRole(res.error);
    else
      messageApi.open({
        type: "success",
        content: `Statut du ${values.mail} mis à jour ${values.status}`,
      });
  };

  return (
    <>
      {contextHolder}
      <Space
        style={{
          backgroundColor: "#f8f9fa",
          border: "1px solid #dee2e6",
          borderRadius: 5,
          padding: 15,
          width: "100%",
        }}
        direction="vertical"
      >
        <Title level={4} style={{ marginBottom: 20 }}>
          Génération de compte
        </Title>
        <Form
          name="basic"
          initialValues={{
            userStatus: "guest",
            qtAccount: 1,
            isKidProfil: false,
            addToSIB: false,
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Row gutter={16}>
            <Col>
              <Form.Item
                label="Mail"
                name="accountName"
                rules={[{ required: true, message: "Please input a mail !" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="Mot de passe"
                name="password"
                rules={[
                  { required: true, message: "Please input a password!" },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Statut" name="userStatus">
                <Select
                  options={[
                    { value: "guest", label: "Guest" },
                    { value: "user", label: "User" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col>
              <Form.Item
                label="Nom du profil"
                name="profilName"
                rules={[
                  { required: true, message: "Please input a profil name !" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="Quantité"
                name="qtAccount"
                rules={[
                  { required: true, message: "Please input a quantity !" },
                ]}
              >
                <InputNumber min={1} max={100} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Profil Enfant" name="isKidProfil">
                <Switch />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Ajouter à SIB" name="addToSIB">
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label="Raison" name="reason">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Enregistrer
            </Button>
          </Form.Item>
        </Form>
        <Text type="danger">{msgErr}</Text>
      </Space>
      <Space
        style={{
          backgroundColor: "#f8f9fa",
          border: "1px solid #dee2e6",
          borderRadius: 5,
          padding: 15,
          marginTop: 10,
          width: "100%",
        }}
        direction="vertical"
      >
        <Title level={4} style={{ marginBottom: 20 }}>
          Mise à jour du rôle
        </Title>
        <Form
          name="role"
          initialValues={{
            status: "guest",
          }}
          onFinish={updateRole}
          autoComplete="off"
          layout="vertical"
        >
          <Row gutter={16}>
            <Col>
              <Form.Item
                label="Mail"
                name="mail"
                rules={[{ required: true, message: "Please input a mail !" }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={10}>
              <Form.Item label="Statut" name="status">
                <Select
                  options={[
                    { value: "guest", label: "Guest" },
                    { value: "user", label: "User" },
                    { value: "admin", label: "Admin" },
                    { value: "subscribed", label: "Abonné" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Enregistrer
            </Button>
          </Form.Item>
        </Form>
        <Text type="danger">{msgErrRole}</Text>
      </Space>
    </>
  );
};

export default ManageAccount;
